import { createApi } from '../callApi';
const contentApi = createApi('CONTENT');

export const fetchWebhooks = (show) => {
    return contentApi({ method: 'GET', target: `/v1/shows/${show}/webhooks` });
};
export const updateWebhooks = (show, body) => {
    return contentApi({ method: 'PUT', target: `/v1/shows/${show}/webhooks`, body });
};
